import { render, staticRenderFns } from "./Mask.vue?vue&type=template&id=a040626c&scoped=true"
import script from "./Mask.vue?vue&type=script&lang=js"
export * from "./Mask.vue?vue&type=script&lang=js"
import style0 from "./Mask.vue?vue&type=style&index=0&id=a040626c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a040626c",
  null
  
)

export default component.exports